///等级转文字
const logLevelExchange = (logLevel) => {
    switch (logLevel) {
        case 2:
            return "普通日志";
        case 3:
            return "接口日志";
        case 4:
            return "警告日志";
        case 5:
            return "异常日志";
        case 6:
            return "关键日志";
        case 7:
            return "关键异常日志";
    }
    return "未知类型"
}

//等级文字颜色
const logLevelColorExchange = (logLevel) => {
    switch (logLevel) {
        case 2:
            return '#000000'
        case 3:
            return '#2c3e50'
        case 4:
            return '#FF8C00'
        case 5:
            return '#ff6b68'
        case 6:
            return '#2c3e50'
        case 7:
            return '#e81511'
    }
    return '#000000'
}

const logLevelList = () => {
    return [
        {"name": "全部日志", value: -1},
        {"name": "普通日志", value: 2},
        {"name": "接口日志", value: 3},
        {"name": "警告日志", value: 4},
        {"name": "异常日志", value: 5},
        {"name": "关键日志", value: 6},
        {"name": "关键异常日志", value: 7}
    ]
}

export default {
    logLevelColorExchange,
    logLevelExchange,
    logLevelList
}